import CommonDatePicker from "@/common/elements/DatePicker";
import FormItem from "@/common/elements/InputElements/FormItem.jsx";
import Select from "@/common/elements/InputElements/Select";
import TextField from "@/common/elements/InputElements/TextField";
import Modal from "@/common/elements/Modal";
import { StyledGridCol, StyledGridRow } from "@/common/styles";
import {
  getOptionsFromRefList,
  isNonEmptyVariable,
} from "@/util/common_function";
import { Button, Form } from "antd";
import { useEffect } from "react";

export const MODE = { NEW: "NEW", EDIT: "EDIT" };

const AssignmentsModal = ({
  show,
  handleCancel,
  formSubmit,
  selectAssignment = null,
  bookingsFieldsEnabled = true
}) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (isNonEmptyVariable(selectAssignment)) {
      form.setFieldsValue(selectAssignment);
    } else {
      form.resetFields();
    }
  }, [selectAssignment]);

  const handleSubmit = () => {
    form.validateFields().then((values) => {
      const data = {
        ...values,
        startDate: isNonEmptyVariable(values?.startDate)
          ? values?.startDate?.format("MM/DD/YYYY")
          : null,
        endDate: isNonEmptyVariable(values?.endDate)
          ? values?.endDate?.format("MM/DD/YYYY")
          : null,
      };
      formSubmit(data);
      form.resetFields();
    });
  };
  function handleFormCancel() {
    form.resetFields();
    handleCancel()
  }
  return (
    <>
      <Modal
        show={show}
        header={`${selectAssignment ? "VIEW" : "ADD"} Assignment Information`}
        onHide={handleFormCancel}
        handleCancel={handleFormCancel}
        handleSubmit={handleSubmit}
        designPattern="ant"
        width="60%"
         footerActions={[
          <Button key="SUBMIT" onClick={handleFormCancel} disabled={!bookingsFieldsEnabled}>
            Close
          </Button>,
          <Button key="SUBMIT" onClick={handleSubmit} disabled={!bookingsFieldsEnabled}>
            Submit
          </Button>
        ]}
      >
        <Form form={form} disabled={!bookingsFieldsEnabled}>
          <StyledGridRow gutter={[16]}>
            <StyledGridCol span={12}>
              <FormItem
                label="Assignment"
                name={["servicesHr", 0, "assignment"]}
              >
                <Select
                  id="assignment"
                  options={getOptionsFromRefList("Staff_Assignment")}
                  disabled={!bookingsFieldsEnabled}
                />
              </FormItem>
            </StyledGridCol>
            <StyledGridCol span={12}>
              <FormItem
                label="Assignment Type"
                name={["servicesHr", 0, "assignmentType"]}
              >
                <Select
                  name="assignmentType"
                  id="assignmentType"
                  options={getOptionsFromRefList("Staff_Assignment_Type")}
                  disabled={!bookingsFieldsEnabled}
                />
              </FormItem>
            </StyledGridCol>
          </StyledGridRow>
          <StyledGridRow gutter={[16]}>
            <StyledGridCol span={12}>
              <FormItem label="Start Date" name="startDate">
                <CommonDatePicker
                  placeholder={"Start Date"}
                  showTime={false}
                  format="MM/DD/YYYY"
                  disabled={!bookingsFieldsEnabled}
                />
              </FormItem>
            </StyledGridCol>
            <StyledGridCol span={12}>
              <FormItem label="End Date" name="endDate">
                <CommonDatePicker
                  placeholder={"End Date"}
                  showTime={false}
                  format="MM/DD/YYYY"
                  disabled={!bookingsFieldsEnabled}
                />
              </FormItem>
            </StyledGridCol>
          </StyledGridRow>
          <StyledGridRow gutter={[16]}>
            <StyledGridCol span={24}>
              <FormItem label="Comment" name={["servicesHr", 0, "comment"]}>
                <TextField inputType="textarea" id="comment" rows={5} />
              </FormItem>
            </StyledGridCol>
          </StyledGridRow>
        </Form>
      </Modal>
    </>
  );
};

export default AssignmentsModal;
